import React from 'react';
import { ChevronDown, ChevronUp, X, Menu } from 'react-feather';
import TextField from 'ui/TextField';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import IconButton from 'ui/IconButton';

const ChoiceRowPreview = ({ position, id, text }) => {
  return (
    <div
      className="d-f fd-r jc-sb ai-c bg-white ml-4 pr-32 SortingChoice-boxShadow"
      style={{ opacity: 0.35 }}
    >
      <div className="d-f ai-c pr-4 pl-4">
        <Menu size={21} />
      </div>
      <div className="minw-25 mr-8">
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD_DARK}>{position}.</Text>
      </div>
      <div className="w-85p mb-8 mr-16">
        <TextField
          whiteBackground
          defaultValue={text}
          name={`SortingChoice-${id}`}
          aria-label={`${t(
            'questions.choices.sorting.items_label',
          )} ${position}`}
          readOnly
        />
      </div>
      <div className="d-f fd-r ai-c">
        <div>
          <IconButton
            type="button"
            className="SortingChoice-arrows SortingChoice-arrows-up"
            aria-label={`${t('common.move_up')} ${position}`}
          >
            <ChevronUp size={24} />
          </IconButton>
          <IconButton
            type="button"
            className="SortingChoice-arrows SortingChoice-arrows-down"
            aria-label={`${t('common.move_down')} ${position}`}
          >
            <ChevronDown size={24} />
          </IconButton>
        </div>
        <IconButton
          type="button"
          aria-label={`${t('common.remove')} ${position}`}
        >
          <X size={32} />
        </IconButton>
      </div>
    </div>
  );
};

export default ChoiceRowPreview;
